import type { StoreContactService } from '@gozoki/api-types'
import type { ComponentType } from 'react'
import {
  AlertSquareIcon,
  HeadsetIcon,
  LaptopProgrammingIcon,
  Truck20Icon,
} from './icons/dashboard-icons'

export interface ServiceContact {
  role: string
  phone: string
}

export interface ServiceTheme {
  /** Fond + bordure de la carte service et de la pastille icône dans la modale. */
  cardBg: string
  cardBorder: string
  /** Couleur du label service + accent (radio sélectionné, bouton Appeler). */
  accent: string
  /** Fond du bouton "Appeler" et texte associé. */
  buttonBg: string
  buttonText: string
  /** Style du CTA dans la carte CONTACT (Urgence = rouge, autres = neutre). */
  ctaBg: string
  ctaBorder: string
  ctaText: string
}

export interface ServiceDefinition {
  key: StoreContactService
  label: string
  subtitle: string
  theme: ServiceTheme
  Icon: ComponentType<{ className?: string }>
  contacts: ServiceContact[]
}

// ⚠️ Contacts et numéros = PLACEHOLDERS (maquette Figma 10263:2300).
// TODO: vrais numéros à fournir par le client, éventuellement par boutique.
export const CONTACT_DIRECTORY: ServiceDefinition[] = [
  {
    key: 'supply',
    label: 'Supply',
    subtitle: 'Approvisionnement & stocks',
    Icon: Truck20Icon,
    theme: {
      cardBg: '#EDF4E8',
      cardBorder: '#507247',
      accent: '#507247',
      buttonBg: '#507247',
      buttonText: '#FFFFFF',
      ctaBg: '#FFFFFF',
      ctaBorder: '#E5EBE5',
      ctaText: '#4F6A47',
    },
    contacts: [
      { role: 'Astreinte Supply', phone: '01 23 45 67 89' },
      { role: 'Responsable appro', phone: '06 12 34 56 78' },
      { role: 'Hub logistique', phone: '05 56 78 12 34' },
    ],
  },
  {
    key: 'sav',
    label: 'S.A.V',
    subtitle: 'Service après-vente',
    Icon: HeadsetIcon,
    theme: {
      cardBg: '#FCF1E6',
      cardBorder: '#EF8031',
      accent: '#EF8031',
      buttonBg: '#EF8031',
      buttonText: '#FFFFFF',
      ctaBg: '#FFFFFF',
      ctaBorder: '#E5EBE5',
      ctaText: '#4F6A47',
    },
    contacts: [
      { role: 'Astreinte SAV', phone: '01 23 45 67 90' },
      { role: 'Support client', phone: '06 12 34 56 79' },
    ],
  },
  {
    key: 'it',
    label: 'I.T',
    subtitle: 'Support informatique',
    Icon: LaptopProgrammingIcon,
    theme: {
      cardBg: '#E8EFF7',
      cardBorder: '#3B6EA5',
      accent: '#3B6EA5',
      buttonBg: '#3B6EA5',
      buttonText: '#FFFFFF',
      ctaBg: '#FFFFFF',
      ctaBorder: '#E5EBE5',
      ctaText: '#4F6A47',
    },
    contacts: [
      { role: 'Astreinte IT', phone: '01 23 45 67 91' },
      { role: 'Hotline technique', phone: '06 12 34 56 80' },
    ],
  },
  {
    key: 'urgence',
    label: 'Urgence',
    subtitle: 'Astreinte urgente',
    Icon: AlertSquareIcon,
    theme: {
      cardBg: '#FEECEC',
      cardBorder: '#FBC6C6',
      accent: '#F25757',
      buttonBg: '#F25757',
      buttonText: '#FFFFFF',
      ctaBg: '#FEECEC',
      ctaBorder: '#FBC6C6',
      ctaText: '#F25757',
    },
    contacts: [
      { role: 'Urgence sécurité', phone: '01 23 45 67 92' },
      { role: 'Astreinte direction', phone: '06 12 34 56 81' },
    ],
  },
]

export const findService = (key: StoreContactService): ServiceDefinition =>
  CONTACT_DIRECTORY.find((service) => service.key === key) ?? CONTACT_DIRECTORY[0]
